import { STATUS_VALUES, type CustomTagDefinition, type TagCategory } from './types';
import { CRM_COPY } from './crm/copy';

/**
 * The tags a company can put on a lead: VIP, the predefined relationship
 * statuses, and the company's own custom definitions — the same three sections
 * `TagPicker` offers per row.
 *
 * Extracted so the bulk bar can offer the catalog as one flat picker without
 * parameterizing TagPicker's popover, which is per-person by construction
 * (`personId`) and gives each section its own chrome.
 */
export interface TagCatalogOption {
  /** `${category}:${value}` — one Select value that round-trips both halves. */
  key: string;
  label: string;
  category: TagCategory;
  value: string;
}

function option(category: TagCategory, value: string, label = value): TagCatalogOption {
  return { key: `${category}:${value}`, label, category, value };
}

export function buildTagCatalog(
  customTagDefinitions: CustomTagDefinition[],
): TagCatalogOption[] {
  return [
    option('vip', 'vip', CRM_COPY.bulk.vipOption),
    ...STATUS_VALUES.map((v) => option('status', v)),
    ...customTagDefinitions.map((d) => option('custom', d.value)),
  ];
}
